module.exports = __webpack_public_path__ + "img/UTFRON-1.0242ea3f.jpg";